import Link from 'next/link'
import React, { FC, ReactNode, useCallback, useEffect, useState } from 'react'

import {
  Box,
  Collapse,
  Divider,
  IconButton,
  ListItem,
  ListItemText
} from '@material-ui/core'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

import Text from '~/components/shared/Text'

type Props = {
  title?: string
  collapsed?: boolean
  disableGutters?: boolean
  disabled?: boolean
  asLink?: boolean
  href?: string
  primary?: string | ReactNode
  divider?: boolean
  collapseOnСhange?: boolean
  closeList?: boolean
  onClick?: () => void
}

const CollapseListItem: FC<Props> = ({
  title,
  collapsed = true,
  children,
  asLink,
  href,
  primary,
  disableGutters,
  collapseOnСhange,
  disabled,
  divider,
  closeList,
  onClick
}) => {
  const [checked, setChecked] = useState(!collapsed)

  const handleChange = () => {
    onClick && onClick()
    setChecked((prev) => !prev)
  }

  const handleCollapseOnChange = useCallback(() => {
    if (!collapseOnСhange) return

    setChecked(false)
  }, [collapseOnСhange])

  useEffect(() => {
    if (disabled || closeList) {
      setChecked(false)
    }
  }, [disabled, closeList])

  const expandIcon = checked ? (
    <ExpandLessIcon color="primary" />
  ) : (
    <ExpandMoreIcon color="primary" />
  )

  const handleClick = (e) => {
    e.preventDefault()
    e.stopPropagation()
    handleChange()
  }

  const item = (
    <ListItem button onClick={!asLink && handleChange} disabled={disabled}>
      <ListItemText
        primary={
          primary || (
            <Text fontSize={14} color="primary" fontFamily="Prompt, sans-serif">
              {title}
            </Text>
          )
        }
      />
      {asLink ? (
        <IconButton
          size="small"
          style={{ padding: '6px' }}
          onClick={handleClick}
        >
          {expandIcon}
        </IconButton>
      ) : (
        expandIcon
      )}
    </ListItem>
  )

  return (
    <>
      {asLink ? (
        <Link href={href} passHref>
          {item}
        </Link>
      ) : (
        item
      )}
      <Collapse in={checked} timeout="auto" unmountOnExit collapsedHeight={0}>
        <Box
          display="flex"
          onClick={handleCollapseOnChange}
          flexDirection="column"
          p={disableGutters ? 0 : 2}
        >
          {children}
        </Box>
      </Collapse>
      {divider && <Divider />}
    </>
  )
}

export default CollapseListItem
